/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/football/match/substitution': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<g clip-path="url(#clip0)" _fill="#000"><path pid="0" d="M3.618 11.972c.202 0 .364-.141.364-.316 0-1.919 1.796-3.48 4.002-3.48h8.732v2.836L21.7 7.86l-4.984-3.153v2.836H7.984c-2.608 0-4.73 1.845-4.73 4.113 0 .175.163.316.364.316zM17.443 5.95l3.02 1.91-3.02 1.91V5.95zM21.081 12.289c-.2 0-.363.141-.363.316 0 1.919-1.796 3.48-4.002 3.48H7.984v-2.836L3 16.401l4.984 3.152v-2.835h8.732c2.608 0 4.73-1.845 4.73-4.113 0-.175-.163-.316-.365-.316zM7.257 18.31l-3.02-1.91 3.02-1.91v3.82z"/></g><defs><clipPath id="clip0"><path pid="1" _fill="#fff" d="M3 4h18.7v16.261H3z"/></clipPath></defs>'
  }
})
